import axios from "axios";

const BASE_API_URL = "/api/user";

//service 層的職責：只負責「怎麼呼叫 API」，不處理 UI 狀態、不 catch 錯誤。
//  錯誤往上拋給元件決定要 toast 還是 dialog —— service 不該知道要怎麼顯示。
class UserService {
  //U-1 取得個人資料
  getProfile() {
    return axios.get(BASE_API_URL + "/profile");
  }

  //U-2 更新個人資料
  //
  //  逐欄列出而不是直接把整包 payload 轉發：後端有白名單（EDITABLE_FIELDS），
  //  這裡列清楚是為了讓「前端到底送了哪些欄位」一眼看得到 ——
  //  轉發整包的話，呼叫端多塞一個 isActive 進來會靜靜地被後端擋掉，
  //  而寫那一行的人不會知道自己寫錯了。
  //
  //  ⚠️ 原本只收 userName / userPhoto，所以生日與性別從這裡送永遠送不出去。
  //  2026-10-28 補上生辰四項（個人資料編輯頁要用）。
  //  undefined 的欄位 axios 不會送出，呼叫端只給想改的那幾個就好。
  updateProfile({
    userName,
    userPhoto,
    userBirthDate,
    userBirthTime,
    userBirthPlace,
    userGender,
  }) {
    return axios.post(BASE_API_URL + "/profile", {
      userName,
      userPhoto,
      userBirthDate,
      userBirthTime,
      userBirthPlace,
      userGender,
    });
  }

  //U-3 註銷帳號
  deactivate() {
    return axios.post(BASE_API_URL + "/deactivate");
  }
}

//單例：全站共用同一個實例，避免每個元件各自 new 一份
const userService = new UserService();
export default userService;
